<template>
  <div class="custom-cards-container">
    <!-- <div class="custom-card" v-for="(event, index) in events" :key="index">
      <img :src="event.image" class="custom-card-image" />
      <div class="custom-card-content">
        <h2 class="custom-card-title">{{ event.title }}</h2>
        <p class="custom-card-subtitle">{{ event.subtitle }}</p>
        <p class="custom-card-description">{{ event.description }}</p>
      </div>
    </div> -->

    <div class="custom-card" v-if="eventStory != null" @click="goToDetails(eventStory.id)">
      <img :src="`https://dlrkgpnmxti0q.cloudfront.net/${eventStory.imageUrl}`" class="custom-card-image" />
      <div class="custom-card-content">
        <h2 class="custom-card-title">{{ eventStory.title }}</h2>
        <!-- <p class="custom-card-subtitle">{{ eventStory.subtitle }}</p> -->
        <p class="custom-card-description">{{ eventStory.description }}</p>
      </div>
    </div>

    <div class="custom-card" v-if="eventStory2 != null" @click="goToDetails(eventStory2.id)">
      <img :src="`https://dlrkgpnmxti0q.cloudfront.net/${eventStory2.imageUrl}`" class="custom-card-image" />
      <div class="custom-card-content">
        <h2 class="custom-card-title">{{ eventStory2.title }}</h2>
        <!-- <p class="custom-card-subtitle">{{ eventStory2.subtitle }}</p> -->
        <p class="custom-card-description">{{ eventStory2.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomCardsContainer",
  props: {
    eventStory: null,
    eventStory2: null,
  },
  data() {
    return {

    };
  },
  methods: {
    goToDetails(id) {
      window.location.href = `/eventdetails/${id}`;
    }
  }
};
</script>

<style scoped>
.custom-cards-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding-left: 30px;
  padding-right: 18px;
  flex-wrap: wrap;
}

.custom-card-subtitle {
  font-size: 11px;
  color: white;
  margin-bottom: 8px;
}

.custom-card {
  flex: 1 1 calc(50% - 10px);
  max-width: calc(50% - 10px);
  height: 600px;
  /* Increased total card height */
  display: flex;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.custom-card-image {
  width: 100%;
  height: 70%;
  /* Fixed height for the image */
  object-fit: cover;
}

.custom-card-content {
  flex-grow: 1;
  /* Takes up remaining space */
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /* Aligns text to the top */
}

.custom-card-title {
  font-size: 16px;
  font-weight: bold;
  color: white;
  margin-bottom: 8px;
}

.custom-card-description {
  font-size: 12px;
  color: white;
  flex-grow: 1;
  /* Allows the description to expand */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  /* Allows more lines */
  -webkit-box-orient: vertical;
}

@media (max-width: 768px) {
  .custom-card {
    flex: 1 1 100%;
    max-width: 100%;
    height: auto;
    /* Flexible height on smaller screens */
  }

  .custom-card-title {
    font-size: 10px !important;
  }

  .custom-card-description {
    font-size: 9px !important;
  }

  .custom-cards-container {
    padding-left: 20px;
  }
}
</style>
